'use client';

import { createStore } from 'zustand';

import { AuthenticatedUser } from '@/types/auth-base.types';
import { tryToLoadAuthenticatedUser } from '@/services/auth/user.service';

export type AuthStoreState = {
  authenticatedUser: AuthenticatedUser | undefined;
};

export type ComputedAuthStoreState = {
  computed: {
    isLoggedIn: boolean;
  };
};

export const authStore = createStore<AuthStoreState & ComputedAuthStoreState>((set, get) => {
  return {
    authenticatedUser: undefined,
    computed: {
      get isLoggedIn() {
        return !!get().authenticatedUser;
      },
    },
  };
});

export const setAuthenticatedUser = (user: AuthenticatedUser | undefined) => {
  authStore.setState({ authenticatedUser: user });
};

export async function logoutUser() {
  authStore.setState({ authenticatedUser: undefined });
  // removeAuthCookies();
}

export async function resolveAuthenticatedUser() {
  const user = await tryToLoadAuthenticatedUser();
  if (!user) {
    return;
  }
  setAuthenticatedUser(user);
}
